/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ----------------------
 * Youtube モーダル
-----------------------*/
// modal open
let modalOpenElems = document.querySelectorAll(".js-modal-open");
modalOpenElems.forEach(function (elem) {
	elem.addEventListener("click", openModalListener);
});

function openModalListener(event) {
	event.preventDefault();//aタグの場合はクリック無効にする

	let videoid = this.getAttribute("data-videoid");
	if (!videoid) {
		return;
	}

	// モーダル部分のHTML生成
	const modalDiv = document.createElement("div");
	modalDiv.id = "youtube__modal";
	modalDiv.className = "youtube__modal";

	const overlayDiv = document.createElement("div");
	overlayDiv.className = "youtube__modal-overlay";
	modalDiv.appendChild(overlayDiv);

	const contentDiv = document.createElement("div");
	contentDiv.className = "youtube__modal-content";
	modalDiv.appendChild(contentDiv);

	const innerDiv = document.createElement("div");
	innerDiv.className = "youtube__modal-inner";
	contentDiv.appendChild(innerDiv);

	const closeLink = document.createElement("a");
	closeLink.className = "youtube__modal-close";
	innerDiv.appendChild(closeLink);

	let iframeElem = document.createElement("iframe");
	iframeElem.src = "https://www.youtube.com/embed/" + videoid;
	iframeElem.title = "YouTube video player";
	iframeElem.frameBorder = "0";
	iframeElem.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
	iframeElem.allowFullscreen = true;
	innerDiv.appendChild(iframeElem);

	document.body.appendChild(modalDiv);

	// modal close
	closeLink.addEventListener("click", function () {
		modalDiv.remove();
	});
}


/* ----------------------
 * ボタンの高さを揃える
-----------------------*/
/**
 * ==============================================================================
 * issue #172: Variant Button Switch
 * ------------------------------------------------------------------------------
 * バリアントメタフィールド `custom.store_only` が true のバリアントが選択された時、
 * ATCボタン・在庫表示・stickyボタンを隠し、代わりに店舗限定問い合わせフォームを表示する。
 * また、Globoフォーム内のhidden input（.js-target-variant / .js-target-variant-id）に
 * 選択中バリアントの情報を注入する。
 *
 * Liquid側で出力される目印:
 *   <script type="application/json" data-vbs-variants="{section.id}">  ... </script>
 *   <div ... data-vbs-buy-wrapper="{section.id}">         （ATCラッパー）
 *   <product-inventory ... data-vbs-inventory-wrapper="{section.id}">   （在庫表示）
 *   <div ... data-vbs-form-wrapper="{section.id}" data-hide-inventory="true|false">
 *   <button ... data-vbs-sticky-btn="{section.id}">       （sticky ATC）
 * ==============================================================================
 */
(function () {
  function initVariantButtonSwitch() {
    var dataScripts = document.querySelectorAll('script[data-vbs-variants]');
    if (!dataScripts.length) return;

    dataScripts.forEach(function (scriptEl) {
      var sectionId = scriptEl.getAttribute('data-vbs-variants');
      var variants;
      try {
        variants = JSON.parse(scriptEl.textContent);
      } catch (e) {
        console.warn('[vbs] Failed to parse variant JSON for section', sectionId, e);
        return;
      }

      var variantMap = {};
      variants.forEach(function (v) { variantMap[String(v.id)] = v; });

      var buyWrap = document.querySelector('[data-vbs-buy-wrapper="' + sectionId + '"]');
      var invWrap = document.querySelector('[data-vbs-inventory-wrapper="' + sectionId + '"]');
      var formWrap = document.querySelector('[data-vbs-form-wrapper="' + sectionId + '"]');
      var stickyBtn = document.querySelector('[data-vbs-sticky-btn="' + sectionId + '"]');
      if (!formWrap) return; // store_only_formブロックが未設置なら何もしない

      var hideInventory = formWrap.getAttribute('data-hide-inventory') === 'true';

      function setHidden(el, hidden) {
        if (!el) return;
        if (hidden) {
          el.setAttribute('hidden', '');
        } else {
          el.removeAttribute('hidden');
        }
      }

      function fillGloboField(className, value) {
        // Custom HTML class はラッパー要素に付与されるケースと input に直接付与されるケースの両対応
        var nodes = formWrap.querySelectorAll('.' + className);
        var filled = false;
        nodes.forEach(function (node) {
          var input = node.matches('input, textarea') ? node : node.querySelector('input, textarea');
          if (input) {
            input.value = value || '';
            // Globoが変更検知するようにイベント発火
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            filled = true;
          }
        });
        return filled;
      }

      // Globoはフォームを非同期レンダリングするため、inputが見つからない場合は
      // MutationObserverで描画を待ってから再注入する
      var _pendingFill = null;
      var _observer = null;
      function scheduleFill(variant) {
        _pendingFill = variant;
        if (_observer) return;
        _observer = new MutationObserver(function () {
          if (!_pendingFill) return;
          var a = fillGloboField('js-target-variant', _pendingFill.title || '');
          var b = fillGloboField('js-target-variant-id', String(_pendingFill.id || ''));
          if (a && b) {
            _pendingFill = null;
            if (_observer) { _observer.disconnect(); _observer = null; }
          }
        });
        _observer.observe(formWrap, { childList: true, subtree: true });
        // 安全装置: 10秒で諦める
        setTimeout(function () {
          if (_observer) { _observer.disconnect(); _observer = null; }
        }, 10000);
      }

      function applyState(variant) {
        if (!variant) return;
        var isStoreOnly = !!variant.store_only;

        setHidden(buyWrap, isStoreOnly);
        setHidden(formWrap, !isStoreOnly);
        if (hideInventory) setHidden(invWrap, isStoreOnly);
        setHidden(stickyBtn, isStoreOnly);

        if (isStoreOnly) {
          var ok1 = fillGloboField('js-target-variant', variant.title || '');
          var ok2 = fillGloboField('js-target-variant-id', String(variant.id || ''));
          // 初回ロード時など、Globoフォームがまだ描画されていなければObserverで待機
          if (!(ok1 && ok2)) {
            scheduleFill(variant);
          }
        }
      }

      // 初期状態: selected_or_first_available_variant をLiquidから取得するのが難しいので
      // URLの?variant=xxx またはDOM上のhidden input[name="id"] から推定する
      function getInitialVariantId() {
        var urlVariantId = new URLSearchParams(window.location.search).get('variant');
        if (urlVariantId && variantMap[urlVariantId]) return urlVariantId;
        var hidden = document.querySelector('[data-vbs-buy-wrapper="' + sectionId + '"] input[name="id"]');
        if (hidden && variantMap[hidden.value]) return hidden.value;
        // フォールバック: 先頭バリアント
        return variants.length ? String(variants[0].id) : null;
      }

      var initialId = getInitialVariantId();
      if (initialId) applyState(variantMap[initialId]);

      // variant:changed はフォーム要素に発火する。document全体でlistenして該当formのものだけ処理
      document.addEventListener('variant:changed', function (event) {
        var variant = event && event.detail && event.detail.variant;
        if (!variant) return;
        var mapped = variantMap[String(variant.id)];
        if (!mapped) return; // このセクションのバリアントではない
        applyState(mapped);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantButtonSwitch);
  } else {
    initVariantButtonSwitch();
  }
})();

window.addEventListener('load', (event) => {
	let elements = document.querySelectorAll('product-list product-item button[type="button"]');
	let maxHeight = 0;

	elements.forEach(function(element) {
		if (element.clientHeight > maxHeight) {
			maxHeight = element.clientHeight;
		}
	});
	elements.forEach(function(element) {
		element.style.height = maxHeight + 'px';
	});
});
  
